export type ResponseErrorAdditionalInfo = {
  error?: string;
  description?: string;
  detail?: string;
  message?: string;
};

const ADDITIONAL_INFO_REGEX = /Additional info:\n\n([\s\S]*?)\n\n/;

const getResponseErrorAdditionalInfo = (
  error: unknown
): ResponseErrorAdditionalInfo | null => {
  const message = (error as { message?: unknown } | null)?.message;

  if (typeof message !== "string") {
    return null;
  }

  const match = message.match(ADDITIONAL_INFO_REGEX);

  if (!match?.[1]) {
    return null;
  }

  try {
    const parsed = JSON.parse(match[1]);

    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    return parsed as ResponseErrorAdditionalInfo;
  } catch {
    return null;
  }
};

export default getResponseErrorAdditionalInfo;
